import React from 'react'

import { FranchiseCard } from '../franchise-card'

import styles from './styles.module.scss'
import { useFranchise } from 'context/franchise'

export const FranchiseList = () => {
  const { franchises: companies } = useFranchise()

  return (
    <div className={styles.container}>
      {companies.map(franchise => (
        <FranchiseCard
          key={franchise.id}
          className={styles.details}
          franchise={franchise}
        />
      ))}
    </div>
  )
}
